import { getSortedI18nNamespaces } from '@/lib/i18n/get-sorted-I18n-namespaces';

const i18nNamespaces = getSortedI18nNamespaces([
  'common',
  'contact',
  'navigation',
]);

export type ContactConfig = {
  i18nNamespaces: typeof i18nNamespaces;
};

export const contactConfig: ContactConfig = {
  i18nNamespaces,
};
